import { z } from "zod";

import { ShippingProfileDtoSchema } from "../../../dtos/shipping-profiles";

export const GetShippingProfilesResponseBodySchema =
  ShippingProfileDtoSchema.array();

export type GetShippingProfilesResponseBodyType = z.infer<
  typeof GetShippingProfilesResponseBodySchema
>;

export const GetShippingProfilesRequestPathParamsSchema = z.object({
  experienceId: z.string().uuid(),
});
export type GetShippingProfilesRequestPathParamsType = z.infer<
  typeof GetShippingProfilesRequestPathParamsSchema
>;
